export interface Response<T> {
  code?: number
  message?: string
  data?: T
}

export enum TASK_STATUS {
  PENDING = 0, // 排队中
  RUNNING = 1, // 进行中
  SUCCESS = 2, // 成功
  FAILED = 3, // 失败
}

export enum VIDEO_TASK_STATUS {
  PENDING = 1, // 排队中
  LOADING = 2, // 生成中
  SUCCESS = 3, // 生成完成
  FAILED = 4, // 生成失败
  TIMEOUT = 5, // 生成超时
}

export enum AUDIT_STATUS {
  NOT_GENERATED = 0, // 未生成
  PENDING = 1, // 待审核
  AUDITING = 2, // 审核中
  PASSED = 3, // 审核通过
  FAILED = 4, // 审核不通过
  EXCEPTION = 5, // 审核异常
}

// 动态漫角色 1-训练师 2-出图师 3-审核师 4-视频师 5-工作室管理员
export enum DYNAMIC_COMIC_ROLE {
  TRAINER = 1, // 训练师
  DRAWER = 2, // 出图师
  AUDITOR = 3, // 审核师
  VIDEO_MAKER = 4, // 视频师
  STUDIO_ADMIN = 5, // 工作室管理员
}
